export const BASE_URL_API = `${process.env.REACT_APP_API_URL}`
